/**
 * @fileoverview POST handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/stop" endpoint
 */
import fetch from "@lib/fetch";

import { decisioningStudioAgentsStopResumeCacheKeys } from "../decisioningStudioAgentsShared/constants";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdStopProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdStopResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdStop = reactQueryMutationAdapter(
  decisioningStudioAgentsStopResumeCacheKeys,
  (
    props: PostDecisioningStudioAgentsAppGroupIdDsaIdStopProps
  ): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdStopResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/stop`,
      "POST",
      undefined,
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
